'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect, useState } from 'react';
const isDev = process.env.NODE_ENV === 'development';
export function MswProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [mswReady, setMswReady] = useState(false);
  useEffect(() => {
    if (!isDev) return;
    const initMsw = async () => {
      try {
        const {
          worker
        } = await import('./browser');
        await worker.start({
          onUnhandledRequest: 'bypass'
        });
      } catch (error) {
        captureException(error);
      } finally {
        setMswReady(true);
      }
    };
    initMsw();
  }, []);
  if (!isDev) return <>{children}</>;
  if (!mswReady) return null;
  return <>{children}</>;
}